/*
 * Cart drawer extras: the free shipping bar and the "You may also like" rail.
 *
 * Both hang off Impulse's own plumbing rather than replacing any of it.
 * theme.js fires cart:updated with the whole cart on every change, and
 * listening for ajaxProduct:added is what makes the drawer rebuild and open,
 * so adding from the rail dispatches that and the theme does the rest.
 */
(function () {
  // Three when there is that much left to offer, fewer as the cart fills up.
  var UPSELL_LIMIT = 3;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- free shipping bar ---------- */

  // Only merch counts toward free shipping. Boat supplies ship separately from
  // TotalBoat and are never discounted, so they don't move the bar. Keep this in
  // step with the Liquid loop in jk-shipping-bar.liquid.
  function merchTotal(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].vendor !== 'TotalBoat') total += cart.items[i].final_line_price;
    }
    return total;
  }

  function updateBars(cart) {
    var bars = document.querySelectorAll('[data-jk-ship]');

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) continue;

      var total = merchTotal(cart);
      bar.hidden = total === 0;

      var remaining = threshold - total;
      var pct = Math.min(100, (total / threshold) * 100);

      var label = bar.querySelector('[data-jk-ship-label]');
      if (label) {
        label.innerHTML = remaining > 0
          ? '<strong>' + money(remaining) + '</strong> away from free shipping on merch'
          : 'Free shipping on merch unlocked';
      }

      var track = bar.querySelector('[data-jk-ship-track]');
      if (track) track.setAttribute('aria-valuenow', Math.round(pct));

      var fill = bar.querySelector('[data-jk-ship-fill]');
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('is-full', remaining <= 0);
      }
    }
  }

  /* ---------- which two to offer ---------- */

  function updateUpsells(cart) {
    var rails = document.querySelectorAll('[data-jk-upsell]');
    if (!rails.length) return;

    var inCart = {};
    for (var i = 0; i < cart.items.length; i++) {
      inCart[cart.items[i].product_id] = true;
    }

    for (var r = 0; r < rails.length; r++) {
      var rail = rails[r];
      var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-jk-upsell-card]'));

      var available = cards.filter(function (card) {
        return !inCart[card.dataset.productId];
      });

      // A bar that stays unfilled after they take the suggestion is worse than
      // no suggestion, so the cheapest item that actually clears the line leads.
      var bar = document.querySelector('[data-jk-ship]');
      var threshold = bar ? parseInt(bar.dataset.threshold, 10) : 0;
      var gap = threshold ? threshold - merchTotal(cart) : 0;

      available.sort(function (a, b) {
        var pa = parseInt(a.dataset.price, 10);
        var pb = parseInt(b.dataset.price, 10);
        if (gap > 0) {
          var ca = pa >= gap;
          var cb = pb >= gap;
          if (ca !== cb) return ca ? -1 : 1;
          return ca ? pa - pb : pb - pa;
        }
        return pb - pa;
      });

      var shown = available.slice(0, UPSELL_LIMIT);
      for (var c = 0; c < cards.length; c++) {
        cards[c].hidden = shown.indexOf(cards[c]) === -1;
      }

      // Put them in the order we just worked out.
      for (var s = 0; s < shown.length; s++) {
        shown[s].parentNode.appendChild(shown[s]);
      }

      rail.hidden = shown.length === 0;
    }
  }

  function refresh(cart) {
    updateBars(cart);
    updateUpsells(cart);
  }

  /* ---------- adding from the rail ---------- */

  function onAdd(evt) {
    var button = evt.target.closest('[data-jk-upsell-add]');
    if (!button) return;

    var card = button.closest('[data-jk-upsell-form]');
    var chosen = card.querySelector('[data-jk-variant]:checked') ||
                 card.querySelector('input[type="hidden"][data-jk-variant]');
    var error = card.querySelector('[data-jk-upsell-error]');

    if (!chosen) {
      if (error) {
        error.textContent = 'Pick a size first.';
        error.hidden = false;
      }
      var first = card.querySelector('[data-jk-variant]:not([disabled])');
      if (first) first.focus();
      return;
    }

    var text = card.querySelector('[data-jk-upsell-add-text]');
    var original = text ? text.textContent : '';

    button.disabled = true;
    if (text) text.textContent = 'Adding';
    if (error) { error.hidden = true; error.textContent = ''; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: chosen.value, quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add that.');
          return data;
        });
      })
      .then(function (product) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        // Impulse rebuilds and opens the drawer off this event.
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: product, addToCartBtn: button }
        }));
        button.disabled = false;
        if (text) text.textContent = original;
      })
      .catch(function (err) {
        button.disabled = false;
        if (text) text.textContent = original;
        if (error) { error.textContent = err.message; error.hidden = false; }
      });
  }

  /* ---------- wiring ---------- */

  // Nothing fires on a cold page load, so read the cart once ourselves.
  function seed() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(refresh)
      .catch(function () {});
  }


  // Impulse fires cart:updated on quantity changes only. An add goes out as
  // ajaxProduct:added and carries the line, not the cart, so re-read the cart.
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) refresh(evt.detail.cart);
  });

  document.addEventListener('ajaxProduct:added', function () {
    seed();
  });

  document.addEventListener('click', onAdd);

  // A size picked is a size that can be added.
  document.addEventListener('change', function (evt) {
    if (!evt.target.matches('[data-jk-upsell-form] [data-jk-variant]')) return;
    var error = evt.target.closest('[data-jk-upsell-form]').querySelector('[data-jk-upsell-error]');
    if (error) error.hidden = true;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seed);
  } else {
    seed();
  }
})();
